if (!customElements.get('component-gallery')) {
  customElements.define('component-gallery', class ComponentGallery extends HTMLElement {
    constructor() {
      super();
      this.cards = this.querySelectorAll('.component-gallery__card');
      this.init();
    }

    init() {
      this.cards.forEach(card => {
        const wrapper = card.closest('.component-gallery__card-wrapper');
        if (!wrapper) return;
        
        const modal = wrapper.querySelector('.component-gallery__modal');
        if (!modal) return;

        const closeBtn = modal.querySelector('.component-gallery__modal-close');
        const overlay = modal.querySelector('.component-gallery__modal-overlay');

        card.addEventListener('click', () => this.open(modal));
        
        card.addEventListener('keydown', (e) => {
          if (e.key === 'Enter') this.open(modal);
        });

        if (closeBtn) closeBtn.addEventListener('click', () => this.close(modal));
        if (overlay) overlay.addEventListener('click', () => this.close(modal));

        modal.addEventListener('cancel', (e) => {
          e.preventDefault();
          this.close(modal);
        });
      });
    }

    open(modal) {
      document.body.style.overflow = 'hidden';
      document.body.style.paddingRight = `${this.getScrollbarWidth()}px`;

      modal.showModal();

      requestAnimationFrame(() => {
        modal.classList.add('is-open');
      });
    }

    close(modal) {
      modal.classList.remove('is-open');

      const handleTransitionEnd = (e) => {
        if (e.target !== modal) return;
        
        modal.removeEventListener('transitionend', handleTransitionEnd);

        if (!modal.classList.contains('is-open')) {
          modal.close();
          document.body.style.overflow = '';
          document.body.style.paddingRight = '';
        }
      };

      modal.addEventListener('transitionend', handleTransitionEnd);
    }

    getScrollbarWidth() {
      return window.innerWidth - document.documentElement.clientWidth;
    }
  });
}